import { element } from "protractor";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { EditAspectDialogComponent } from "app/components/dialog/edit-aspect-dialog/edit-aspect-dialog.component";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ClienteService } from "app/service/cliente/cliente.service";

export interface FormType {
  clientId: number;
  modeloAlfresco: number;
  descricao: string;
  nome: string;
  tipoPrimario: number;
  titulo: string;
}
@Component({
  selector: "app-criar-aspectos",
  templateUrl: "./criar-aspectos.component.html",
  styleUrls: ["./criar-aspectos.component.scss"],
})
export class CriarAspectosComponent implements OnInit {
  public datasourceAspecto: FormGroup;
  public modelos: any[] = [];
  public clientes: ClienteModel[];
  public isLoading = true;
  public idAspectSaved;
  nodesByModel: any[];
  nodesFiltered = [];
  selectedPrimaryType = null;
  public titulo = false;
  public prefixModel: string;
  public idClient: number;

  constructor(
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CriarAspectosComponent>,
    public configPastaService: ConfigurarPastaServiceService,
    private clienteService: ClienteService,
    private dialogoRef: MatDialogRef<CriarAspectosComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idClient = data.clientId;
  }

  ngOnInit() {
    this.datasourceAspecto = this.fb.group({
      id: [""],
      nome: [{ value: "", disabled: true }, Validators.required],
      modeloAlfresco: ["", Validators.required],
      tipoPrimario: [""],
      titulo: ["", Validators.required],
      descricao: [""],
      isNovoTipo: [true],
      isContainer: [false],
      isAtivo: [true],
      isAspect: [true],
    });
    this.listarClientesUsuario();
    this.listarModelosInterface();
  }

  teste() {
    console.log(this.modelos);
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarModelos() {
    this.configPastaService.getModelosAlfresco().subscribe(
      (dados) => {
        dados.forEach((element) => {
          if (element.clientId == this.idClient) {
            this.modelos.push(element);
          }
          this.isLoading = false;
        });
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  listarModelosInterface() {
    this.configPastaService.getModelosAlfrescoInterafece().subscribe(
      (dados) => {
        dados.forEach((element) => {
          if (element.clientId == this.idClient) {
            this.modelos.push(element);
          }
          this.isLoading = false;
        });
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  // listarAspectByModel(modelId: number) {
  //   this.configPastaService.getAspectByModelId(modelId).subscribe(
  //     (data) => {
  //       this.nodesByModel = data;
  //       this.nodesFiltered = [...data];
  //     },
  //     (err) => {
  //       console.error(err);
  //       this.isLoading = false;
  //     }
  //   );
  // }
  listarNodesByModel(modelId: number) {
    this.isLoading = true;
    this.configPastaService.getAspectByModelId(modelId).subscribe(
      (data) => {
        this.isLoading = false;
        this.nodesByModel = data;
        this.nodesFiltered = [...data];
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onModelSelectionChange() {
    const idModelo = this.datasourceAspecto.get("modeloAlfresco").value;
    this.listarNodesByModel(idModelo);
    this.modelos.forEach((element) => {
      if (element.id === idModelo) {
        this.prefixModel = element.prefix;
      }
    });
    console.log(this.prefixModel);
  }

  onPrimTypeSelectionChange() {}

  onSearch(value: string, mode: string) {
    const filter = value.toLowerCase();

    switch (mode) {
      case "TIPOPRIMARIO":
        this.nodesFiltered = this.nodesByModel.filter((node) =>
          node.title.toLowerCase().startsWith(filter)
        );
        break;
      default:
        break;
    }
  }

  onSaveAspect() {
    if (this.datasourceAspecto.valid) {
      this.datasourceAspecto.get("nome").enable();

      const valueNome = this.datasourceAspecto.get("nome").value;
      const aspectToCreate: FormType = this.datasourceAspecto.value;

      this.configPastaService.createNewAspect(aspectToCreate).subscribe(
        (data) => {
          this.configPastaService.isChangedNode.next();
          this.openSnackBar("Aspecto criado com sucesso!", false);
          this.isLoading = false;
          this.datasourceAspecto.get("nome").reset();
          // this.datasourceAspecto.get("modeloAlfresco").reset();
          this.datasourceAspecto.get("descricao").reset();
          this.datasourceAspecto.get("titulo").reset();

          // console.log("sucess");
          // this.openSnackBar("Aspecto criado com sucesso!", false);
          // this.dialogRef.close(data);
          // this.isLoading = false;
          // this.dialogoRef.close(data);
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        }
      );
    } else {
      this.openSnackBar("Preencha todos os campos obrigatórios !", true);
    }
  }

  formatarNome(e) {
    const str = e.target.value;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    this.datasourceAspecto.get("nome").setValue(nameFormated);

    const valueModeloAlfresco =
      this.datasourceAspecto.get("modeloAlfresco").value;
    if (valueModeloAlfresco >= 1) {
      this.datasourceAspecto
        .get("nome")
        .setValue(this.prefixModel + ":" + nameFormated);
    } else {
      this.datasourceAspecto.get("nome").setValue(nameFormated);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/vincular-tipo-cliente/criar-aspectos/criar-aspectos.component.ts